<xux-form-panel
  [title]="gridTitleObs | async"
  [description]="descriptionObs | async"
  [panelId]="field.widgetData?.groupId"
  [ngClass]="field.class"
  [class.panel-header-padding]="!field?.description"
>
  <xvi-toolbar
    panel-heading-content
    [buttons]="headerButtons"
    [click]="handleHeaderButtonClick"
  >
  </xvi-toolbar>

  <xvi-label-block panel-body-content [labels]="(topLabels | async) || []"></xvi-label-block>
  <xvi-label-block panel-body-content [labels]="warningLabels || []"></xvi-label-block>
  <xux-grid-custom
    panel-body-content
    class="xux-list"
    [columns]="gridColumns"
    [items]="initXuxGridItems"
    [view]="gridView"
    [options]="gridOptions"
    [userGridOptions]="userGridOptions"
    [showLoader]="field.widgetData?.showLoader | async"
    [buttons]="gridButtons"
    [rowButtons]="rowButtons"
    [userComponents]="dmCustomGridComponents"
    [pinnedTopRowData]="pinnedTopRowData"
    [ngClass]="selectTheDisabledClass()"
    [artificialInputCheckForSearchPanel]="
      field.widgetData?.artificialInputCheckForSearchPanel
    "
    (action)="onGridAction($event)"
    [i18n]="staticI18nTextContent.xuxGrid"
  >
  </xux-grid-custom>

  <xvi-error-block
    panel-body-content
    *ngIf="!field.widgetData.hiddenErrorBlock"
    [control]="field?.control"
    [showPristineErrors]="showPristineErrors"
  ></xvi-error-block>
</xux-form-panel>
